import { Card, Collapse, Divider, Flex, Space, Statistic, Typography } from "antd";
import { useContext, useState } from "react";
import VSpace from "../../../../common/VSpace";
import { centsToDollarsDisplay } from "../../../../displayFormatters";
import { GetJobByIdResponse } from "../../../jobsApi";
import { useGetJobByIdQuery } from "../../../jobsQueries";
import JobPlanContext from "../../JobPlanContext";

const { Text } = Typography

type Props = {
  jobId: number
}

const JobDetails = ({ jobId }: Props) => {
  const { jobEstimatedHours, jobFinalPrice } = useContext(JobPlanContext) 
  const [isCollapsed, setIsCollapsed] = useState(false);
  const getJobByIdQuery = useGetJobByIdQuery(jobId)
  const jobDetails = getJobByIdQuery.data ?? {} as GetJobByIdResponse

  return <Card styles={{ body: { padding: 0 } }} style={{ borderColor: 'rgba(0, 0, 0, 0.15)' }}>
    <Collapse
      onChange={() => setIsCollapsed(!isCollapsed)}
      items={[
        {
          id: 'jobName',
          label: <VSpace>
            <Text strong>{jobDetails.jobName}</Text>
            {
              !isCollapsed && <VSpace>
                <Text>{jobDetails.customerName}</Text>
                <Space>
                  <Text type='secondary'>{jobDetails.jobNo}</Text>
                  <Text>{centsToDollarsDisplay(jobFinalPrice) || ''}</Text>
                  <Divider type='vertical' style={{ height: '1em' }} />
                  <Text type='secondary'>{jobEstimatedHours} h</Text>
                </Space>
              </VSpace>
            }
          </VSpace>,
          children: <VSpace>
            <Flex wrap='wrap' justify='space-between'>
              <JobInfoStatistic title="Hours" value={jobEstimatedHours} />
              <JobInfoStatistic title="Price" value={centsToDollarsDisplay(jobFinalPrice) || ''} />
            </Flex>
            <JobInfoStatistic title="Job Number" value={jobDetails.jobNo} />
            <JobInfoStatistic title="Customer Name" value={jobDetails.customerName} />
            <JobInfoStatistic title="Customer Address" value={jobDetails.propertyAddress1} />
          </VSpace>
        }
      ]}
      ghost
    />
  </Card>
}

export default JobDetails

const JobInfoStatistic = ({ title, value }: { title: string, value: string | number }) => <Statistic title={title} value={value} valueStyle={{ fontSize: 16 }} />